module.exports = __webpack_public_path__ + "images/garmin_stream_instruction.webp";